module.exports = "<div class=\"modal fade\" data-backdrop=\"static\" id=\"swMask\">\n    <div class=\"loading\" *ngIf=\"tip\"><i></i>{{tip}}</div> \n</div>"